import { render, staticRenderFns } from "./BlockType14List.vue?vue&type=template&id=c540dfe0&scoped=true&"
import script from "./BlockType14List.vue?vue&type=script&lang=ts&"
export * from "./BlockType14List.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType14List.vue?vue&type=style&index=0&id=c540dfe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c540dfe0",
  null
  
)

export default component.exports